export default __webpack_public_path__ + "static/media/BFSInfo.0e12f400.md";